module.exports = __webpack_public_path__ + "static/media/you-tube.f5ae8521.svg";